// /web/src/pages/Benefits.jsx
import React from "react";

const benefits = [
  {
    title: "Quantify briefs instantly",
    body: "Translate planning briefs into concrete metrics without spreadsheet wrangling. Pebbledash structures inputs so you can focus on design intent.",
  },
  {
    title: "Spot risks early",
    body: "Surface compliance gaps across lifts, cores, sanitary provision and cycling before they become costly redesign cycles.",
  },
  {
    title: "Share decisions clearly",
    body: "Package calculators, notes and exports together so clients and consultants see how each assumption affects the outcome.",
  },
];

const calculators = [
  {
    title: "Lift traffic",
    detail:
      "Model handling capacity, car counts and peak interval assumptions so vertical transportation stays smooth across mixed-use schemes.",
  },
  {
    title: "WC provision",
    detail:
      "Balance gender-neutral, accessible and traditional layouts while checking every floor against BCO, Part T and local guidance.",
  },
  {
    title: "Stairs & cores",
    detail:
      "Size escape stairs and convenience cores with instant feedback on widths, occupancy and travel distances for each scenario.",
  },
  {
    title: "Cycling & amenities",
    detail:
      "Count long-stay parking, lockers and showers in seconds so end-of-trip provision keeps pace with planning expectations.",
  },
  {
    title: "Risers & plant",
    detail:
      "Coordinate risers, shafts and plant zones early, including service separation and spare capacity for future upgrades.",
  },
  {
    title: "End-of-trip",
    detail:
      "Map circulation, access control and amenity layouts so cyclists and runners have a seamless arrival and departure experience.",
  },
];

export default function BenefitsPage() {
  return (
    <div>
      <section className="pd-section" aria-labelledby="benefits-hero">
        <div className="pd-container" style={{ maxWidth: "840px" }}>
          <p className="pd-eyebrow">Benefits</p>
          <h1 id="benefits-hero" className="pd-display">
            Why practices choose Pebbledash
          </h1>
          <p className="pd-lead">
            Equip your team with calculators that keep feasibility work fast, evidenced and easy to explain to stakeholders.
          </p>
        </div>
      </section>

      <section className="pd-section pd-section--alt">
        <div className="pd-container" style={{ maxWidth: "960px" }}>
          <div className="pd-features-grid">
            {benefits.map((item) => (
              <article key={item.title} className="pd-feature">
                <h2 className="pd-h3">{item.title}</h2>
                <p className="pd-muted">{item.body}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="pd-section pd-section--tint-navy" aria-labelledby="benefits-calculators">
        <div className="pd-container">
          <h2 id="benefits-calculators" className="pd-h2">
            Operational calculators, explained
          </h2>
          <p className="pd-lead">
            Every tool is built for feasibility speed. Walk stakeholders through the logic one calculator at a time.
          </p>

          <ol className="pd-steps--media">
            {calculators.map((calc, index) => (
              <li key={calc.title} className="pd-step--media">
                <div className="pd-step__text">
                  <span className="pd-step__num">{`0${index + 1}`}</span>
                  <div>
                    <h3 className="pd-h3">{calc.title}</h3>
                    <p className="pd-muted">{calc.detail}</p>
                  </div>
                </div>
                <div className="pd-step__media" role="img" aria-label={`Placeholder for ${calc.title} calculator`}>
                  <div className="pd-media-placeholder">Media Placeholder</div>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </section>

      <section className="pd-section" aria-labelledby="benefits-demo">
        <div className="pd-container" style={{ maxWidth: "840px" }}>
          <h2 id="benefits-demo" className="pd-h2">
            See the calculators in action
          </h2>
          <p className="pd-muted">
            Drop your walkthrough video here to show how Pebbledash keeps feasibility work aligned across teams.
          </p>
          <div className="pd-media-placeholder" style={{ marginTop: "32px" }}>
            Media Placeholder
          </div>
        </div>
      </section>
    </div>
  );
}
